/**
 * The ResponsiveValue class manages
 * values for specific viewport widths
 */
export class ResponsiveValue<const T> {
    /**
     * Constructor
     *
     * @param {Record<number, T>} [values={}]
     */
    public constructor(protected values: Record<number, T> = {}) {}

    /**
     * Method to set a value for a minimum viewport width
     *
     * @param {number} minWidth
     * @param {T} value
     * @returns {void}
     */
    public set(minWidth: number, value: T): void {
        this.values[minWidth] = value;
    }

    /**
     * Method to get the value for the current viewport width
     *
     * @param {number} [width=window.innerWidth]
     * @returns {T | null}
     */
    public get(width: number = window.innerWidth): T | null {
        const applicable = Object.keys(this.values)
            .map(Number)
            .filter((minWidth) => minWidth <= width)
            .sort((a, b) => b - a);

        if (applicable.length) {
            return this.values[applicable[0]];
        }
        return null;
    }
}
